import _, { get }                       from '_';
import { isIpad, isMobile, isApp }      from 'utils/util';
import React, { PropTypes }             from 'react';
import Reflux                           from 'reflux';
import VideoActions                     from 'actions/video_actions';
import VideoStore                       from 'stores/video_store';
import DescriptorStore                  from 'stores/descriptor_store';
import StandalonePlayer                 from 'components/standalone_player';
import BrandPlayChapters                from 'components/brand_play/chapters';
import QNAPresenter                     from 'components/qna/qna_standalone_presenter';


require('brandStyle');
/* conditionally load template based on className in <body>, use utility functions (isMobile etc.)
 *require('templates_mv_isi');
 * templates_mv_isi:  __dirname + '/assets/css/template_mv-isi.scss',
 * templates_mv:      __dirname + '/assets/css/template_mv-no-isi.scss',
 * templates_sv_isi:  __dirname + '/assets/css/template_sv-isi.scss',
 * templates_sv:      __dirname + '/assets/css/template_sv-no-isi.scss'
 */

export default React.createClass({
  displayName: 'Player.BrandPlay',
  propTypes: {
    descriptorURL: PropTypes.string,
    descriptorJSON: PropTypes.object
  },
  polling: true,
  mixins: [ Reflux.connect(VideoStore) ],
  getInitialState() {
    return {
      showMore: false
    };
  },
  componentDidMount() {
    $('.episode-title').remove();
    $('#notes, .magnify').on('click', function() {
      VideoStore.mediaApi.pause();
    });
    $(window)
        .on('player:pause', () => {
          VideoStore.mediaApi.pause();
        })
        .on('player:play', () => {
          VideoStore.mediaApi.play();
        });
    let selectedVideo, selectedVideoCSS, chapterMenu = $('.chapter-link-in-menu');

    $('[data-video]').on('click', function() {
        selectedVideo = $(this).data('video') - 1;
        selectedVideoCSS = '#chapter-' + $(this).data('video');
        VideoActions.selectVideo(DescriptorStore.state.videos[selectedVideo], selectedVideo);
        $('.chapter-link-in-menu').removeClass('now_playing_color');
        $(selectedVideoCSS).addClass('now_playing_color');
    });

    $(window).on('hashchange', function() {
      try {
          let index = 0, video = Number(window.location.hash.substr(1)),
              selectedVideoCSS = "#chapter-" + video;
          if(video){
              if(video < 1 && video > bpInstance.videos.length){
              } else {
                  index = video-1;
              }
          }
          VideoActions.selectVideo(DescriptorStore.state.videos[index], index);
          VideoStore.mediaApi.play();
          if(chapterMenu.length > 0) {
              chapterMenu.removeClass('now_playing_color');
              $(selectedVideoCSS).addClass('now_playing_color');
          }
      } catch(err) {
        console.log(err.message);
      }
    });
    //setTimeout(() => { addLinkTrackVars('contextData.wb.spcrtid'); }, 1000);
  },
  interstitial(videoIndex) {
    const videos  = DescriptorStore.state.videos,
        isAuto    = _.get(this.state.descriptor, 'defaultVideoOptions.shouldAutoplay');
    if(isAuto && videos[next]) {
      VideoActions.selectVideo(videos[next], next);
    }
  },
  showMore() {
    this.setState({
      showMore: true
    });
  },
  replayVideo(){
    $('.video-player-standalone').show();
    VideoStore.mediaApi.replay();
  },
  nextVideo(videoIndex){
    const videos         = DescriptorStore.state.videos;
    let next = VideoStore.getIndex()+1;

    $('.video-player-standalone').show();

    if(next < videos.length){
      VideoActions.selectVideo(videos[next], next);
    } else {
      VideoActions.selectVideo(videos[0], 0);
    }
  },
  componentWillUpdate(nextProps, nextState) {
    if(typeof this.state.video != 'undefined'){
      if(typeof this.state.video.isEnded != 'undefined'){
        if(this.state.video.isEnded && $('.qna-radio-form').length === 0){
          this.polling = true;
        } else {
          if(this.state.video.index !== nextState.video.index){
            this.polling = true;
          } else {
            this.polling = false;
          }
        }
      }
    }
  },
  render: function() {
    let title, headerURL, isiLinks, chapters, videoIndex, viewed, page, ended, qnaFlg;
    const hasMobileStyle = isMobile() && !isIpad();
    const useMobileMenu = isMobile() ? (bpInstance.mobileMenu ? true : false) : false;
    if(useMobileMenu) $('body').addClass('has-mobile-menu');
    if(get(this, 'state.video.meta', false)) {
          headerURL = DescriptorStore.state.headerURL;
           isiLinks = DescriptorStore.state.isiLinks;
           chapters = DescriptorStore.state.videos;
              title = this.state.video.meta.title;
         videoIndex = this.state.video.index;
             viewed = this.state.video.viewed;
              page = this.props.descriptorJSON.videos[videoIndex].page;
             ended = this.state.video.isEnded;
             qnaFlg = this.props.descriptorJSON.videos[videoIndex].qna;
    }
    let showMore = null;
    if(hasMobileStyle && !this.state.showMore) {
      showMore = (<div onClick={this.showMore} className="show-more">SHOW MORE
                    <div className="show-more-border"></div>
                 </div>);
    }
    let qid = this.props.descriptorJSON.qid;
    if(!($(".cme-chart").length > 0) && this.polling) {
      this.component = React.createElement(new QNAPresenter(qid, page), {qid, page});
    }
    let qnaElement;
    if(!VideoStore.state.isPlaying && ended && qnaFlg) {
      qnaElement = (<div className="qna-container">
                  {this.component}
                  <div className="video-qna">
                    <button className="qna-button replay-video" onClick={this.replayVideo}>Replay Video</button>
                    <button className="qna-button next-video" onClick={this.nextVideo}>Next Video</button>
                  </div>
                </div>);
    } else {
      qnaElement = '';
    }
    return (
        <div className="brand-play">
            <div className="brand-play-player">
             <div className="brand-play-poll-wrapper">
                <StandalonePlayer
                  id="brand-player"
                  onVideoEnd={this.interstitial}
                  videoIndex={videoIndex}
                  descriptorURL={ this.props.descriptorURL }
                  descriptorJSON={ this.props.descriptorJSON }
                  />
                 {qnaElement}
             </div>
              <BrandPlayChapters
                chapters={chapters}
                index={parseInt(videoIndex, 10)}
                headerURL={headerURL}
                title={title}
                isiLinks={isiLinks}
                hasMobileStyle={hasMobileStyle}
                showMore={this.state.showMore}
                viewed={viewed}
                useMobileMenu={useMobileMenu}
              />
              { showMore }
            </div>
        </div>
    );
  }
});



// WEBPACK FOOTER //
// ./modules/components/brand_play.jsx